import { Plus, PlusCircle, Trash2 } from 'lucide-react';
import React, { useState } from 'react';
import AddBlockCustomFeatureModal from './AddBlockCustomFeatureModal';

const FeatureCountStepper = ({ value, onChange }) => (
  <div className="community-advanced-stepper community-custom-feature-stepper">
    <span className="community-advanced-label">Count</span>
    <div className="community-stepper-controls">
      <button
        type="button"
        disabled={value <= 1}
        onClick={() => onChange(Math.max(1, value - 1))}
      >
        −
      </button>
      <span>{value}</span>
      <button
        type="button"
        disabled={value >= 50}
        onClick={() => onChange(Math.min(50, value + 1))}
      >
        +
      </button>
    </div>
  </div>
);

const BlockCustomFeaturesSection = ({ features = [], onChange }) => {
  const [showAdd, setShowAdd] = useState(false);

  const addFeature = feature => {
    onChange([...features, feature]);
    setShowAdd(false);
  };

  const updateFeature = (index, patch) => {
    const next = [...features];
    next[index] = { ...next[index], ...patch };
    onChange(next);
  };

  const removeFeature = index => {
    onChange(features.filter((_, i) => i !== index));
  };

  return (
    <div className="community-custom-features">
      <div className="community-custom-features-header">
        <div>
          <h5 className="community-custom-features-title">Custom Features</h5>
          <p className="community-custom-features-subtitle">
            {features.length === 0
              ? 'Add block-specific infrastructure'
              : `${features.length} custom feature${features.length === 1 ? '' : 's'}`}
          </p>
        </div>
        <button
          type="button"
          className="community-custom-features-add-btn"
          onClick={() => setShowAdd(true)}
        >
          <Plus className="w-4 h-4" />
          Add
        </button>
      </div>

      {features.length === 0 ? (
        <button
          type="button"
          className="community-custom-features-empty"
          onClick={() => setShowAdd(true)}
        >
          <PlusCircle className="w-7 h-7" />
          <span className="community-custom-features-empty-title">Create custom feature</span>
          <span className="community-custom-features-empty-hint">
            Service lift, garbage chute, ramp…
          </span>
        </button>
      ) : (
        <>
          {features.map((feature, index) => (
            <div key={feature.id} className="community-custom-feature-tile">
              <div className="community-custom-feature-tile-header">
                <span className="community-custom-feature-tile-name">{feature.name}</span>
                <button
                  type="button"
                  className="community-custom-feature-remove"
                  title="Remove"
                  onClick={() => removeFeature(index)}
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              <FeatureCountStepper
                value={feature.count ?? 1}
                onChange={count => updateFeature(index, { count })}
              />
            </div>
          ))}
          <button
            type="button"
            className="community-outline-btn community-custom-features-add-another"
            onClick={() => setShowAdd(true)}
          >
            <Plus className="w-4 h-4" />
            Add another feature
          </button>
        </>
      )}

      {showAdd && (
        <AddBlockCustomFeatureModal
          onAdd={addFeature}
          onClose={() => setShowAdd(false)}
        />
      )}
    </div>
  );
};

export default BlockCustomFeaturesSection;
